"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMeResponseApiSchema = exports.doctorAttendingApiRelationSchema = exports.medicalAssistantApiRelationSchema = void 0;
const zod_1 = require("zod");
const doctor_substitute_1 = require("../doctor-substitutes/doctor-substitute");
const address_schema_1 = require("../global/address.schema");
const api_1 = require("../global/api");
const profile_schema_1 = require("../global/profile.schema");
const enums_1 = require("../medical-assistants/enums");
const user_1 = require("./user");
/**
 * JSON:API relation describing the current user's medical assistant profile,
 * included in `GET /users/me` when the user has the `medical_assistant` role.
 * Mirrors the doctor relations so the profile can be prefilled client-side.
 */
exports.medicalAssistantApiRelationSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('medical-assistants'),
    attributes: zod_1.z.object({
        email: zod_1.z.string().email(),
        firstname: zod_1.z.string(),
        lastname: zod_1.z.string(),
        phone: zod_1.z.string().nullable().default(null),
        contractType: enums_1.contractTypeSchema,
        weeklyHours: zod_1.z.number().int(),
        hireDate: zod_1.z.coerce.date(),
        dateOfBirth: zod_1.z.coerce.date().nullable().default(null),
        birthPlace: zod_1.z.string().nullable().default(null),
        nationality: zod_1.z.string().nullable().default(null),
        socialSecurityNumber: zod_1.z.string().nullable().default(null),
        address: address_schema_1.assistantAddressSchema.nullable().default(null),
    }),
});
exports.doctorAttendingApiRelationSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('doctor-attendings'),
    attributes: zod_1.z.object({
        // Always present - office assignment info
        officeId: zod_1.z.string().uuid(),
        officeName: zod_1.z.string(),
        // Optional - doctor profile fields (only on first item since shared at Doctor level)
        dateOfBirth: zod_1.z.coerce.date().nullable().optional(),
        address: address_schema_1.addressSchema.nullable().optional(),
        orderRegistrationNumber: zod_1.z.string().optional(),
        rppsNumber: zod_1.z.string().optional(),
        thesis: zod_1.z.boolean().optional(),
        rhythm: zod_1.z.string().nullable().optional(),
        onSiteSlotsWithoutAssistant: zod_1.z.number().int().nullable().optional(),
        remoteSlotsWithoutAssistant: zod_1.z.number().int().nullable().optional(),
        onSiteSlotsWithAssistant: zod_1.z.number().int().nullable().optional(),
        remoteSlotsWithAssistant: zod_1.z.number().int().nullable().optional(),
        rhythmNote: zod_1.z.string().nullable().optional(),
        iban: zod_1.z.string().optional(),
        bic: zod_1.z.string().nullable().optional(),
        signatureUrl: profile_schema_1.signatureUrlSchema.optional(),
    }),
});
exports.getMeResponseApiSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: (0, api_1.apiEntityTypeSchema)('users'),
        attributes: zod_1.z.object({
            email: zod_1.z.string().email(),
            picture: profile_schema_1.pictureSchema,
            role: user_1.userRoleSchema,
            firstname: zod_1.z.string(),
            lastname: zod_1.z.string(),
            phoneNumber: zod_1.z.string().nullable().default(null),
            siteIds: zod_1.z.array(zod_1.z.string().uuid()).default([]),
            officeIds: zod_1.z.array(zod_1.z.string().uuid()).default([]),
        }),
        relationships: zod_1.z.object({
            doctorSubstitute: (0, api_1.apiEntityRelationshipSchema)('doctor-substitutes').optional(),
            doctorAttending: (0, api_1.apiEntityRelationshipsSchema)('doctor-attendings')
                .optional()
                .default({ data: [] }),
            medicalAssistantProfile: (0, api_1.apiEntityRelationshipSchema)('medical-assistants').optional(),
        }),
    }),
    included: zod_1.z
        .array(zod_1.z.union([
        doctor_substitute_1.doctorSubstituteApiRelationSchema,
        exports.doctorAttendingApiRelationSchema,
        exports.medicalAssistantApiRelationSchema,
    ]))
        .optional()
        .default([]),
});
